import axios from 'axios'

const BASE_URL = 'https://api.ideal-postcodes.co.uk/v1'

export const getLatLngForPostcode = async (postcode) => {
  if (!postcode || postcode.trim().length === 0) {
    throw new Error('Postcode is required')
  }

  try {
    const cleanPostcode = postcode.replace(/\s/g, '').toUpperCase()
    const response = await axios.get(
      `${BASE_URL}/postcodes/${cleanPostcode}/?api_key=${process.env.REACT_APP_POSTCODE_API_KEY}`
    )

    const result = response.data?.result
    const first = Array.isArray(result) ? result[0] : result
    const post_town = first?.post_town || 'London' // Default to London if post_town is missing
    const post_code = first?.postcode || '' // Use input postcode if API doesn't return one
    const lat = first?.latitude
    const lng = first?.longitude

    if (typeof lat === 'number' && typeof lng === 'number') {
      return { lat, lng, post_town, post_code }
    }

    // Some Ideal Postcodes responses may return strings
    const latNum = lat !== undefined ? Number(lat) : NaN
    const lngNum = lng !== undefined ? Number(lng) : NaN
    if (Number.isFinite(latNum) && Number.isFinite(lngNum)) {
      return { lat: latNum, lng: lngNum, post_town: post_town, postcode: post_code }
    }

    throw new Error('No latitude/longitude returned for this postcode')
  } catch (error) {
    console.error(error)
    if (error.response?.status === 404) {
      throw new Error('No location found for this postcode')
    } else if (error.response?.status === 401) {
      throw new Error('Invalid API key')
    } else if (error.response?.status === 400) {
      throw new Error('Invalid postcode format')
    } else {
      throw new Error(`Postcode lookup failed: ${error.message}`)
    }
  }
}

export const getAddressFromLatLng = async (lat, lng) => {
  const response = await fetch(
    `https://api.ideal-postcodes.co.uk/v1/addresses?api_key=${process.env.REACT_APP_POSTCODE_API_KEY}&lon=${lng}&lat=${lat}`
  )

  const data = await response.json()

  if (!data.result?.hits?.length) {
    throw new Error('No address found')
  }

  const address = data.result.hits[0]

  return {
    postcode: address.postcode,
    town: address.post_town,
    county: address.county,
    country: address.country,
    line1: address.line_1,
    line2: address.line_2,
  }
}

export const searchAddressByPostcode = async (postcode) => {
  if (!postcode || postcode.trim().length === 0) {
    throw new Error('Postcode is required')
  }

  try {

    const cleanPostcode = postcode.replace(/\s/g, '').toUpperCase()

    const response = await axios.get(`${BASE_URL}/postcodes/${cleanPostcode}/?api_key=${process.env.REACT_APP_POSTCODE_API_KEY}`)
    //response is a list of addresses for postcode

    if (response.data?.result && Array.isArray(response.data?.result)) {
      return response.data.result.map((item, index) => {
        const formattedAddress = item.line_1 + ", " + item.line_2 + ", " + item.post_town + ", " + item.postcode

        return {
          id: index,
          formatted: formattedAddress,
          line_1: item.line_1,
          line_2: item.line_2,
          line_3: '',
          line_4: '',
          locality: '',
          town_or_city: item.post_town,
          county: item.county,
          district: '',
          country: 'England',
          postcode: item.postcode,
          // getAddressUrl: item.url,
        }
      })
    }

    return []
  } catch (error) {
    console.error(error)
    if (error.response?.status === 404) {
      throw new Error('No addresses found for this postcode')
    } else if (error.response?.status === 401) {
      throw new Error('Invalid API key')
    } else if (error.response?.status === 400) {
      throw new Error('Invalid postcode format')
    } else {
      throw new Error(`Address lookup failed: ${error.message}`)
    }
  }
}

export const formatAddressForDisplay = (address) => {
  return address.formatted || address.address || 'Invalid address'
}

// export const getDetailedAddress = async (url) => {
//   //OLD POSTCODE API, IF FUNCTION NEEDED, WILL NEED TO BE UPDATED TO MATCH NEW API
//   if (!API_KEY) {
//     throw new Error('getAddress.io API key not configured')
//   }

//   try {
//     const response = await axios.get(`${BASE_URL}${url}`, {
//       params: {
//         'api-key': API_KEY,
//       },
//     })

//     return response.data
//   } catch (error) {
//     throw new Error(`Failed to get detailed address: ${error.message}`)
//   }
// }
